export class KeyboardModel {
    public id: number;
    public keyboardPreference: number;
}